import { ThemeOptions } from '@mui/material';

declare module '@mui/material/LinearProgress' {
  // tslint:disable-next-line:interface-name
  interface CircularProgressPropsColorOverrides {
    primaryShadowed: true;
    secondaryShadowed: true;
    errorShadowed: true;
    infoShadowed: true;
    successShadowed: true;
    warningShadowed: true;
  }
}

export const MuiLinearProgress: ThemeOptions['components']['MuiLinearProgress'] = {
  styleOverrides: {
    root: () => {
      return {
        borderRadius: '100px'
      };
    }
  }
};
